import React, { useState } from "react";
import LabServices from "./LabServices";
import ConsultationManagement from "./ConsultationManagement";
import AdminInventoryPriceManager from "./AdminInventoryPriceManager";

const PricingManagement = () => {
  const [activeTab, setActiveTab] = useState("lab");

  const tabs = [
    { key: "lab", label: "Lab Services", component: <LabServices /> },
    { key: "med", label: "Medication Prices", component: <AdminInventoryPriceManager /> },
    { key: "consultation", label: "Consultation Prices", component: <ConsultationManagement /> },
  ];

  return (
    <div className="space-y-4">
      {/* Tab Buttons */}
      <div className="flex mt-[10px] gap-[5px] justify-end">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`px-4 py-2 rounded ${
              activeTab === tab.key ? "primary extra-wide" : "secondary"
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div>
        {tabs.find((tab) => tab.key === activeTab)?.component}
      </div>
    </div>
  );
};

export default PricingManagement;
